import type { RouteLocationNormalizedLoaded, Router } from "vue-router";
import { isAndroid, isNativePlatform } from "../capacitor/platform";

/**
 * Navigate to /home after authentication completes.
 *
 * Apple native builds must navigate within the bundled SPA. A full-page load
 * of /home is unreliable in WKWebView and can leave the login modal on screen
 * even after authentication succeeds. Detect this as "native and not Android"
 * rather than depending on getPlatform() returning "ios": the latter can be
 * unavailable during early WebView startup even though isNativePlatform() is
 * already true. Web and Android retain the server navigation so
 * userSpaShellHandler can perform auto-browse and referrer redirects.
 */
export async function postLoginNavigate(route: RouteLocationNormalizedLoaded, router: Router): Promise<void> {
  if (isNativePlatform() && !isAndroid()) {
    await router.replace({ name: "Home", query: route.query });
    return;
  }

  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(route.query)) {
    if (value != null) params.set(key, String(value));
  }
  const qs = params.toString();
  window.location.assign("/home" + (qs ? "?" + qs : ""));
}
